import React, { FC } from 'react';

import { Svg, SvgProps } from '@lglp/components';

import styles from './Error504Icon.module.scss';

const Error504Icon: FC<Error504IconProps> = ({ className, ...rest }) => {
  return (
    <Svg
      viewBox="0 0 518 305"
      className={[styles.error404Icon, className]}
      {...rest}
    >
      <g>
        <g>
          <text
            transform="translate(2 2) translate(341 238)"
            className={styles.cls1}
            fill="#215382"
            fontFamily="Montserrat-ExtraBold, Montserrat"
            fontSize="246px"
            fontWeight="800"
          >
            <tspan x="0" y="0">
              4
            </tspan>
          </text>
          <text
            transform="translate(2 2) translate(341 238)"
            className={styles.cls1}
            fill="none"
            stroke="#215382"
            strokeLinecap="round"
            strokeWidth="2px"
            fontFamily="Montserrat-ExtraBold, Montserrat"
            fontSize="246px"
            fontWeight="800"
          >
            <tspan x="0" y="0">
              4
            </tspan>
          </text>
          <path
            fill="none"
            stroke="#215382"
            strokeLinecap="round"
            strokeWidth="2px"
            d="M691.3 262.654c0 57.618-32.426 90.793-76.825 90.793-44.649 0-77.074-33.175-77.074-90.793s32.425-90.794 77.074-90.794m27.188 90.794c0-36.667-11.474-50.386-27.188-50.386-15.964 0-27.438 13.719-27.438 50.386s11.474 50.384 27.438 50.384c15.716 0 27.19-13.719 27.19-50.384z"
            transform="translate(2 2) translate(-366.388 -108.528)"
          />
          <text
            transform="translate(2 2) translate(0 239)"
            className={styles.cls1}
            fill="#215382"
            fontFamily="Montserrat-ExtraBold, Montserrat"
            fontSize="247px"
            fontWeight="800"
          >
            <tspan x="0" y="0">
              5
            </tspan>
          </text>
          <text
            transform="translate(2 2) translate(0 239)"
            className={styles.cls1}
            fill="none"
            stroke="#215382"
            strokeLinecap="round"
            strokeWidth="2px"
            fontFamily="Montserrat-ExtraBold, Montserrat"
            fontSize="247px"
            fontWeight="800"
          >
            <tspan x="0" y="0">
              5
            </tspan>
          </text>
          <path
            fill="none"
            stroke="#215382"
            strokeDasharray="15"
            strokeLinecap="round"
            strokeWidth="2px"
            d="M537.4 262.654c0-57.619 32.425-90.794 77.074-90.794 44.4 0 76.825 33.175 76.825 90.794s-32.426 90.793-76.825 90.793c-44.646-.001-77.074-33.175-77.074-90.793zm104.262 0c0-36.667-11.474-50.386-27.188-50.386-15.964 0-27.438 13.719-27.438 50.386s11.474 50.384 27.438 50.384c15.717 0 27.191-13.719 27.191-50.384z"
            transform="translate(2 2) translate(-366.388 -108.528)"
          />
        </g>
      </g>
    </Svg>
  );
};

type Error504IconProps = SvgProps;

export default Error504Icon;
